import React from 'react';

import { Bag } from '@order/features-ordering';

import { useBagFeaturedUpsell, type useOrderState } from '../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const BagFeaturedUpsell = (props: Props) => {
  const { orderState } = props;

  // ───────────────────────────────────────────────────────────────────────────

  const {
    isDialogOpen,
    isDialogContentVisible,
    isAdding,
    isAdded,
    isAnimating,
    content,
    addCta,
    addToBag,
    dismiss,
    close,
    finishAnimation,
  } = useBagFeaturedUpsell({ orderState });

  if (!content) {
    return null;
  }

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <>
      <Bag.Upsell.Featured.Dialog
        isOpen={isDialogOpen}
        isContentVisible={isDialogContentVisible}
        accessibilityLabel={content.headline}
        onRequestClose={close}
      >
        <Bag.Upsell.Featured.Card
          content={content}
          addCta={addCta}
          isAdding={isAdding}
          isAdded={isAdded}
          onAdd={addToBag}
          onDismiss={dismiss}
        />
      </Bag.Upsell.Featured.Dialog>

      {isAnimating && content.animationImageUrl ? (
        <Bag.Upsell.Featured.Confetti
          imageUrl={content.animationImageUrl}
          onFinish={finishAnimation}
        />
      ) : null}
    </>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  orderState: ReturnType<typeof useOrderState>;
};
